import $ from 'jquery';

$.postJSON = function (url, params) {
    return this.post(url, params, null, 'json');
};
